
import { selectLangObj } from '../../../reducers/langReducer.js';
import {  useSelector } from 'react-redux';

function PersonDetails({ details }) {

  const langObj = useSelector(selectLangObj);




  return (
    <div className='py-5 px-5 rounded-xl  flex flex-col gap-3 items-start '>
      {details?.mestoRodjenja && (
        <div>
          {langObj["BornIn"]} : {details.mestoRodjenja}
        </div>
      )}

      {(details?.imeOca || details?.imeMajke) && (
        <div>
          {langObj["Parents"]} : {details?.imeOca || ""}
          {details?.imeOca && details?.imeMajke ? ", " : ""}
          {details?.imeMajke || ""}
        </div>
      )}

      {details?.deca?.length > 0 && (
        <div>
          {langObj["Children"]} : {details.deca.join(", ")}
        </div>
      )}

      {details?.suprug && (
        <div>
          {langObj["Spouse"]} : {details.suprug}
        </div>
      )}

    </div>
  );
}

export default PersonDetails;
